/*
 * @Author: 杜娇艳 12104317+du-jiaoyan@user.noreply.gitee.com
 * @Date: 2025-06-15 14:41:20
 * @LastEditors: jiaoyan.du jiaoyan.du@huifu.com
 * @LastEditTime: 2025-06-27 15:39:08
 * @FilePath: /game-console/src/utils/request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "axios";
import router from "../router";
import store from "../store";
import Vue from "vue";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 根据环境变量设置基础URL
  timeout: 10000, // 请求超时时间
  headers: {
    "Content-Type": "application/json;charset=uft-8",
  },
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    if (config["method"] === "get") {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
      let urlStr = "";
      if (typeof config.data === "object") {
        Object.keys(config.data).forEach(function (key) {
          if (config.data[key] !== undefined) {
            urlStr = urlStr
              ? urlStr + "&" + key + "=" + config.data[key]
              : key + "=" + config.data[key];
          }
        });
        config.url = config.url + "?" + urlStr;
      }
    }
    if (config["type"] === "upload") {
      config.headers["Content-Type"] = "multipart/form-data";
    }
    // 在请求发送之前做一些处理
    const token = store.state.token;
    if (token) {
      config.headers["token"] = token;
    }
    return config;
  },
  (error) => {
    // 请求错误处理
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.statusCode === 401) {
      Vue.prototype.$message({
        message: "登录超时请退出重新登录",
        type: "warning",
        duration: 3000,
      });
      store.dispatch("user/resetToken").then(() => {
        location.reload();
      });
    } else if (res.statusCode === 101) {
      Vue.prototype.$message({
        message: res.message || "无效参数",
        type: "warning",
        duration: 3000,
      });
    } else if (res.statusCode === -1) {
      Vue.prototype.$message({
        message: res.message || "系统异常",
        type: "error",
        duration: 3000,
      });
    } else {
      return res;
    }
  },
  (error) => {
    // 响应错误处理
    console.log("err" + error); // for debug

    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 未授权，跳转到登录页
          store.commit("CLEAR_AUTH");
          router.replace({
            path: "/login",
            query: { redirect: router.currentRoute.fullPath },
          });
          break;
        case 403:
          // 禁止访问
          error.message = "拒绝访问";
          break;
        case 404:
          // 资源不存在
          error.message = "请求资源不存在";
          break;
        case 500:
          // 服务器错误
          error.message = "服务器错误";
          break;
      }
    }

    return Promise.reject(error);
  }
);

export default service;
